export const RequisasComprasReporteLang = {
    // ENCABEZADO
    TituloReporte: {
        es: 'Requisición Compras',
        en: 'Purchase Requisition',
    },
    fechaCreacion: {
        es: 'Fecha de Creación: ',
        en: 'Date Created: ',
    },
    area: {
        es: 'Área: ',
        en: 'Area: ',
    },
    tipo: {
        es: 'Tipo: ',
        en: 'Type: ',
    },
    creadoPor: {
        es: 'Creado Por: ',
        en: 'Created By: ',
    },
    solicitadoPor: {
        es: 'Solícitado Por: ',
        en: 'Requested By: ',
    },

// TABLA
    codigo: {
        es: 'CÓDIGO',
        en: 'CODE',
    },
    producto: {
        es: 'PRODUCTO',
        en: 'PRODUCT',
    },
    cantidad: {
        es: 'QTY',
        en: 'CANT.',
    },
    unidad: {
        es: 'UNIDAD',
        en: 'UNIT',
    },
    moneda: {
        es: 'MONEDA',
        en: 'CURRENCY',
    },
    precio: {
        es: 'PRECIO',
        en: 'PRICE',
    },
    isv: {
        es: 'ISV',
        en: 'TAX',
    },
    descuento: {
        es: 'DESC.',
        en: 'DISC.',
    },
    comentario: {
        es: 'Comentario.',
        en: 'Comment.',
    },
    detallesEn: {
        es: 'Detalles en ',
        en: 'Details in ',
    },


    // FIRMAS
    elaboradoPor: {
        es: 'Elaborado Por',
        en: 'Created By',
    },
    autorizadoPor: {
        es: 'Autorizado Por',
        en: 'Approved By',
    },
    Finanzas: {
        es: 'Finanzas',
        en: 'Received By',
    },
    GerentePlanta: {
        es: 'Gerente Planta',
        en: 'Plant Manager',
    },

    // FOOTER
    fechaImpresion: {
        es: 'Fecha de Impresión: ',
        en: 'Printing Date: ',
    },
    original: {
        es: 'Original: Cliente',
        en: 'Original: Client ',
    },
    copia: {
        es: 'Copia: Contabilidad',
        en: 'Copy: Accounting ',
    },
}